import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteModule } from '@autocomplete';
import { AutocompleteWithControlsModule } from '@shared/modules/autocomplete-with-controls';
import { MaterialModule } from '@material';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskModule } from 'ngx-mask';
import { CoreModule } from '../core/core.module';
import { AddressComponentsModule } from './modules/address-components/address-components.module';
import { AddressRecipientNoteComponent } from '../components/invoice-form/components/address-recipient-note/address-recipient-note.component';
import { AddressRecipientComponent } from '../components/invoice-form/components/address-recipient/address-recipient.component';
import { ContactRecipientCounterpartyComponent } from '../components/invoice-form/components/contact-recipient-counterparty/contact-recipient-counterparty.component';
import { ContactRecipientComponent } from '../components/invoice-form/components/contact-recipient/contact-recipient.component';
import { ContactSenderComponent } from '../components/invoice-form/components/contact-sender/contact-sender.component';
import { ContactTypesModule } from '../components/invoice-form/components/contact-types/contact-types.module';
import { RecipientCounterpartyRadioGroupComponent } from '../components/invoice-form/components/recipient-counterparty-radio-group/recipient-counterparty-radio-group.component';
import { RecipientSearchComponent } from '../components/invoice-form/components/recipient-search/recipient-search.component';
import { RecipientComponent } from '../components/invoice-form/components/recipient/recipient.component';
import { AdditionalServicesModule } from '../components/invoice-form/components/services/additional-services.module';
import { AddressSenderModule } from '../components/invoice-form/modules/address-sender.module';
import { PipeModule } from '../pipes/pipes.module';
import { AccompanyingDocumentsComponent } from './components/accompanying-documents/accompanying-documents.component';
import { AddBirthDateComponent } from './components/add-birth-date/add-birth-date.component';
import { AddToRegisterComponent } from './components/add-to-register/add-to-register.component';
import { AddressComponent } from './components/addresses/address/address.component';
import { EditContainerComponent } from './components/addresses/edit-container/edit-container.component';
import { PostboxComponent } from './components/addresses/postbox/postbox.component';
import { AddressBlockComponent } from './components/addresses/recipient-address/address-block.component';
import { WarehouseComponent } from './components/addresses/warehouse/warehouse.component';
import { BackInvoicesFormComponent, BackSuccessPopupComponent } from './components/back-invoices-form';
import { BannerComponent } from './components/banner/banner.component';
import { ChangeCustomerReturnComponent } from './components/change-customer-return/change-customer-return.component';
import { ChangeEwContactInputComponent } from './components/change-ew/change-ew-contact-input/change-ew-contact-input.component';
import { ChangeEwModalComponent } from './components/change-ew/change-ew-modal/change-ew-modal.component';
import { ChangeEwSuccessPopupComponent } from './components/change-ew/change-ew-success-popup/change-ew-success-popup.component';
import { ChangeEwComponent } from './components/change-ew/change-ew.component';
import { ContactOrganizationChangeEwComponent } from './components/change-ew/contact-organization-change-ew/contact-organization-change-ew.component';
import { PrivatePersonFormChangeEwComponent } from './components/change-ew/private-person-form-change-ew/private-person-form-change-ew.component';
import { PrivatePersonSenderFormChangeEwComponent } from './components/change-ew/private-person-sender-form/private-person-sender-form.component';
import { ConfirmDialogModule } from './components/confirm-dialog';
import { ContactEditComponent } from './components/contact-edit/contact-edit.component';
import { ErrorSnackbarComponent } from './components/error-snackbar/error-snackbar.component';
import {
  CourierPickupAttachingComponent,
  CourierPickupRemoveInvoiceConfirmComponent,
  CourierPickupsListComponent,
} from './components/courier-pickup';
import { CreateContactComponent } from './components/create-contact/create-contact.component';
import { CreateTemplateDialogComponent } from './components/create-template-dialog/create-template-dialog.component';
import { CustomGridFooterComponent } from './components/custom-grid-footer/custom-grid-footer.component';
import { CustomTooltipComponent } from './components/custom-tooltip/custom-tooltip.component';
import { DebtPopupComponent } from './components/debt-popup/debt-popup.component';
import { DeliveryAdditionalInfoComponent } from './components/delivery-additional-info/delivery-additional-info.component';
import { DeliveryBarcodeComponent } from './components/delivery-barcode/delivery-barcode.component';
import { DeliveryCargoCommonComponent } from './components/delivery-cargo/components/delivery-cargo-common/delivery-cargo-common.component';
import { DeliveryCargoPlacesComponent } from './components/delivery-cargo/components/delivery-cargo-places/delivery-cargo-places.component';
import { DeliverySeatsCheckboxComponent } from './components/delivery-cargo/components/delivery-seats-checkbox/delivery-seats-checkbox.component';
import { DeliveryCargoComponent } from './components/delivery-cargo/delivery-cargo.component';
import { DeliveryCostComponent } from './components/delivery-cost/delivery-cost.component';
import { DeliveryDescriptionComponent } from './components/delivery-description/delivery-description.component';
import { DeliveryDocumentsAmountComponent } from './components/delivery-documents/components/delivery-documents-amount/delivery-documents-amount.component';
import { DeliveryDocumentsComponent } from './components/delivery-documents/delivery-documents.component';
import { DeliveryPackingNumberComponent } from './components/delivery-packing-number/delivery-packing-number.component';
import { DeliveryPalletSeatsComponent } from './components/delivery-pallets/components/delivery-pallet-seats/delivery-pallet-seats.component';
import { DeliveryPalletsComponent } from './components/delivery-pallets/delivery-pallets.component';
import { DeliveryThirdPersonComponent } from './components/delivery-payer/components/delivery-third-person/delivery-third-person.component';
import { DeliveryPayerComponent } from './components/delivery-payer/delivery-payer.component';
import { DeliveryPaymentComponent } from './components/delivery-payment/delivery-payment.component';
import { DeliveryPromocodeComponent } from './components/delivery-promocode/delivery-promocode.component';
import { DonateButtonComponent } from './components/donate-button/donate-button.component';
import { HeaderChatComponent } from './components/header-chat/header-chat.component';
import { InvoiceFullInfoModalComponent } from './components/invoice-full-info-modal/invoice-full-info-modal.component';
import { InvoiceInfoComponent } from './components/invoice-info/invoice-info.component';
import { InvoiceNavbarComponent } from './components/invoice-navbar/invoice-navbar.component';
import { InvoiceStatusTabsComponent } from './components/invoice-status-tabs/invoice-status-tabs.component';
import { StatusTabComponent } from './components/invoice-status-tabs/status-tab/status-tab.component';
import { LightReturnModalConfirmedComponent } from './components/light-return-modal/light-return-modal-confirmed/light-return-modal-confirmed.component';
import { LightReturnModalComponent } from './components/light-return-modal/light-return-modal.component';
import { LogoComponent } from './components/logo/logo.component';
import { MessengersPopupInstructionComponent } from './components/messengers-popup/messengers-popup-instruction/messengers-popup-instruction.component';
import { MessengersPopupComponent } from './components/messengers-popup/messengers-popup.component';
import { OrganizationAutocompleteComponent } from './components/organization-autocomplete/organization-autocomplete.component';
import { PartialSuccessComponent } from './components/partial-success/partial-success.component';
import { PrintingSettingComponent } from './components/pringitng-setting/printing-setting.component';
import { PrivatePersonFormComponent } from './components/private-person-form/private-person-form.component';
import { RedirectInvoicesFormComponent, RedirectSuccessPopupComponent } from './components/redirect-invoices-form';
import { InvoiceDetailedInfoComponent } from './components/redirect-invoices-form/components/invoice-detailed-info/invoice-detailed-info.component';
import { InvoiceShortInfoComponent } from './components/redirect-invoices-form/components/invoice-short-info/invoice-short-info.component';
import { RecommendationWarehousesComponent } from './components/redirect-invoices-form/components/recommendation-warehouses/recommendation-warehouses.component';
import { NewRegisterComponent } from './components/registries/new-register';
import { RegisterRenameComponent } from './components/registries/register-rename/register-rename.component';
import { RegistersShowComponent } from './components/registries/registers-show/registers-show.component';
import { RegistersViewComponent } from './components/registries/registers-view/registers-view.component';
import { ShareTemplateMessageComponent } from './components/registries/share-template-message/share-template-message.component';
import { ServicesBannerComponent } from './components/services-banner/services-banner.component';
import { ShareInvoiceStateComponent } from './components/share-invoice-state/share-invoice-state.component';
import { InvoiceTrackedFullInfoModalComponent } from './components/show-invoice-tracked/components/invoice-tracked-full-info-modal/invoice-tracked-full-info-modal.component';
import { ShowInvoiceTrackedComponent } from './components/show-invoice-tracked/show-invoice-tracked.component';
import { InvoiceTransportProcessInformerComponent } from './components/invoice-transport-process-informer/invoice-transport-process-informer.component';
import { ShowInvoiceComponent } from './components/show-invoice/show-invoice.component';
import { TableColFilterModule } from './components/table-col-filter/table-col-filter.module';
import { TableFilterMenuModule } from './components/table-filter-menu/table-filter-menu.module';
import { IframeLoadHandlerDirective } from './directives/iframe-load-handler/iframe-load-handler.directive';
import { InvoiceDirectivesModule } from './directives/invoice-directives/invoice-directives.module';
import { OrderNumberDirective } from './directives/order-number/order-number.directive';
import { CopyClipboardModule } from './modules/copy-clipboard/copy-clipboard.module';
import { NgEditTableCellModule } from './modules/edit-table-cell/edit-table-cell.module';
import { AppMatTableModule } from './modules/mat-table/app-mat-table.module';
import { NgStfAccordeonModule } from './modules/ng-stf-accordeon/ng-stf-accordeon.module';
import { PhoneInputModule } from './modules/phone-input/phone-input.module';
import { TableToolbarModule } from './modules/table-toolbar/table-toolbar.module';
import {
  PersonalManagerPopupComponent
} from "./components/messengers-popup/personal-manager-popup/personal-manager-popup.component";
import { PersonalManagerStubComponent } from "./components/personal-manager-stub/personal-manager-stub.component";
import { FinancialMonitoringModule } from './components/financial-monitoring/financial-monitoring.module';
import { BecomePayerDialogComponent } from './components/become-payer-dialog';
import { RegistersMainComponent } from './components/registries/registers-main/registers-main.component';
import {
  IntRegisterShowComponent
} from './components/registries/registers-international/components/int-register-show/int-register-show.component';
import {
  NewInternationalRegisterComponent
} from './components/registries/registers-international/components/new-international-register';
import { InternationalRegisterRenameComponent } from './components/registries/international-register-rename/international-register-rename.component';
import {
  IntRegistersViewComponent
} from './components/registries/registers-international/components/int-registers-view/int-registers-view.component';
import { EmptyContactInfoStubComponent } from './components/empty-contact-info-stub/empty-contact-info-stub.component';
import { InvoiceProgressStateComponent } from './components/invoice-progress-state/invoice-progress-state.component';
import {
  ProgressStateInformerComponent
} from './components/invoice-progress-state/components/progress-state-informer/progress-state-informer.component';
import {
  ShowInvoiceMyInternationalComponent
} from './components/show-invoice-my-international/show-invoice-my-international.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { StoreComponent, ContractButtonComponent, SimpleBannerModule } from './components';
import {
  ShowInvoiceInternationalComponent
} from './components/show-invoice-international/show-invoice-international.component';
import { DocumentPreviewComponent } from './components/document-preview/document-preview.component';

const COMPONENTS = [
  InvoiceProgressStateComponent,
  ProgressStateInformerComponent,
  ErrorSnackbarComponent,
  BannerComponent,
  PrintingSettingComponent,
  HeaderChatComponent,
  DebtPopupComponent,
  AddBirthDateComponent,
  LogoComponent,
  ServicesBannerComponent,
  RecipientComponent,
  RecipientSearchComponent,
  ContactRecipientComponent,
  ContactRecipientCounterpartyComponent,
  RecipientCounterpartyRadioGroupComponent,
  AddressRecipientComponent,
  AddressRecipientNoteComponent,
  ContactSenderComponent,
  InvoiceInfoComponent,
  ShareInvoiceStateComponent,
  ChangeEwContactInputComponent,
  ChangeEwModalComponent,
  ChangeEwComponent,
  ContactOrganizationChangeEwComponent,
  PrivatePersonFormChangeEwComponent,
  PrivatePersonSenderFormChangeEwComponent,
  CreateTemplateDialogComponent,
  CustomGridFooterComponent,
  InvoiceFullInfoModalComponent,
  InvoiceStatusTabsComponent,
  StatusTabComponent,
  PrivatePersonFormComponent,
  InvoiceDetailedInfoComponent,
  InvoiceShortInfoComponent,
  RecommendationWarehousesComponent,
  RedirectInvoicesFormComponent,
  ShowInvoiceComponent,
  ShowInvoiceInternationalComponent,
  InvoiceTransportProcessInformerComponent,
  ShowInvoiceTrackedComponent,
  InvoiceTrackedFullInfoModalComponent,
  AddToRegisterComponent,
  BackInvoicesFormComponent,
  ChangeCustomerReturnComponent,
  RegistersViewComponent,
  RegistersMainComponent,
  IntRegistersViewComponent,
  IntRegisterShowComponent,
  RegisterRenameComponent,
  InternationalRegisterRenameComponent,
  RegistersShowComponent,
  ShareTemplateMessageComponent,
  ContactEditComponent,
  PrivatePersonFormComponent,
  InvoiceShortInfoComponent,
  RedirectSuccessPopupComponent,
  BackSuccessPopupComponent,
  InvoiceDetailedInfoComponent,
  PrivatePersonFormChangeEwComponent,
  PrivatePersonSenderFormChangeEwComponent,
  ContactOrganizationChangeEwComponent,
  CustomGridFooterComponent,
  AddressBlockComponent,
  EditContainerComponent,
  WarehouseComponent,
  AddressComponent,
  PostboxComponent,
  MessengersPopupComponent,
  MessengersPopupInstructionComponent,
  DeliveryPromocodeComponent,
  DeliveryBarcodeComponent,
  AccompanyingDocumentsComponent,
  CreateContactComponent,
  DeliveryPackingNumberComponent,
  DeliveryAdditionalInfoComponent,
  DeliveryDocumentsComponent,
  DeliveryDocumentsAmountComponent,
  DeliveryPalletsComponent,
  DeliveryPalletSeatsComponent,
  DeliveryCargoComponent,
  DeliveryCargoCommonComponent,
  DeliveryCargoPlacesComponent,
  DeliverySeatsCheckboxComponent,
  DeliveryCostComponent,
  DeliveryDescriptionComponent,
  DeliveryPayerComponent,
  DeliveryThirdPersonComponent,
  DeliveryPaymentComponent,
  InvoiceNavbarComponent,
  LightReturnModalComponent,
  LightReturnModalConfirmedComponent,
  DonateButtonComponent,
  IframeLoadHandlerDirective,
  CourierPickupAttachingComponent,
  CourierPickupsListComponent,
  CourierPickupRemoveInvoiceConfirmComponent,
  PartialSuccessComponent,
  OrderNumberDirective,
  ChangeEwSuccessPopupComponent,
  NewRegisterComponent,
  NewInternationalRegisterComponent,
  PersonalManagerPopupComponent,
  PersonalManagerStubComponent,
  BecomePayerDialogComponent,
  OrganizationAutocompleteComponent,
  EmptyContactInfoStubComponent,
  ShowInvoiceMyInternationalComponent,
  CustomTooltipComponent,
  ContractButtonComponent,
  StoreComponent,
  DocumentPreviewComponent,
];

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CoreModule,
    AddressComponentsModule,
    PhoneInputModule,
    ContactTypesModule,
    AutocompleteWithControlsModule,
    PipeModule,
    AddressSenderModule,
    InvoiceDirectivesModule,
    ConfirmDialogModule,
    CopyClipboardModule,
    NgStfAccordeonModule,
    NgxMaskModule.forRoot(),
    AdditionalServicesModule,
    AppMatTableModule,
    TableToolbarModule,
    NgEditTableCellModule,
    TableColFilterModule,
    AutocompleteModule,
    TextMaskModule,
    TableFilterMenuModule,
    FinancialMonitoringModule,
    OverlayModule,
    SimpleBannerModule,
  ],
  declarations: COMPONENTS,
  exports: [...COMPONENTS, NgxMaskModule, AutocompleteModule, FinancialMonitoringModule, SimpleBannerModule],
})
export class SharedModule {}
